import { useState } from 'react';
import './PopupMensaje.css';
import logoPolicia from '../../assets/svg/policia.svg';

const PopupMensaje = ({ mensaje, onClose }) => {
    const [showPopup, setShowPopup] = useState(true);

    const handleClose = () => {
        setShowPopup(false);
        onClose();
    };

    return (
        <div>
            {showPopup && (
                <>
                    <div className="popup-overlay" onClick={handleClose}></div>
                    <div className="popup-container">
                        <img src={logoPolicia} alt="logo policia" />
                        <p>{mensaje}</p>
                        <button className='boton-secundario' onClick={handleClose}>Cerrar</button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PopupMensaje;
